import { Box } from '@mui/material';
import { usePracticePayers } from 'apps/wrapper/src/hooks/use-practice-payers';
import { AppointmentRequestDetails } from 'apps/wrapper/src/services/appointment/types/appointment-request-details';
import moment from 'moment';
import { FC } from 'react';
import { LabeledSection } from '../labeled-section/labeled-section';
import { LabeledText } from '../labeled-text/labeled-text';

export interface InsuranceInfoSectionProps {
  insuranceInfo: AppointmentRequestDetails['insuranceInfo'];
}

export const InsuranceInfoSection: FC<InsuranceInfoSectionProps> = ({ insuranceInfo }) => {
  const { getPayerNameById } = usePracticePayers();

  if (!insuranceInfo) {
    return null;
  }

  const { carrier, subscriberFirstName, subscriberLastName, memberId, subscriberDateOfBirth } = insuranceInfo;

  // Only render if at least one field has a value
  const hasAnyValue = carrier || subscriberFirstName || subscriberLastName || memberId || subscriberDateOfBirth;
  if (!hasAnyValue) {
    return null;
  }

  const formatDateOfBirth = (dob?: string) => {
    if (!dob) return '-';
    const m = moment(dob);
    return m.isValid() ? m.format('MM/DD/YYYY') : '-';
  };

  const getCarrierDisplayName = (carrierId?: string) => {
    if (!carrierId) return '-';
    return getPayerNameById(carrierId) || carrierId;
  };

  return (
    <LabeledSection label="Insurance Information">
      <LabeledText label="Subscriber Provider">{getCarrierDisplayName(carrier)}</LabeledText>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <LabeledText label="Subscriber first name" sx={{ flex: 1 }}>
          {subscriberFirstName || '-'}
        </LabeledText>
        <LabeledText label="Subscriber last name" sx={{ flex: 1 }}>
          {subscriberLastName || '-'}
        </LabeledText>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <LabeledText label="Member ID" sx={{ flex: 1 }}>
          {memberId || '-'}
        </LabeledText>
        <LabeledText label="Subscriber date of birth" sx={{ flex: 1 }}>
          {formatDateOfBirth(subscriberDateOfBirth)}
        </LabeledText>
      </Box>
    </LabeledSection>
  );
};
